import ApiService from '@/core/services/ApiService';
import { Actions, Mutations } from '@/store/enums/StoreEnums';
import { Module, Action, Mutation, VuexModule } from 'vuex-module-decorators';

export interface BadgeObject {
  id: number;
  slug: string;
  titleEn: string;
  titleAr: string;
  descriptionEn: string;
  descriptionAr: string;
  icon: string;
  isActive: boolean;
}

export interface BadgesListInfo {
  totalItems: number;
  currentPage: number;
  pageSize: number;
  isNext: boolean;
  previous: number;
  badges: Array<BadgeObject>;
  errors: unknown;
}

@Module
export default class BadgesModule extends VuexModule implements BadgesListInfo {
  badges = [] as Array<BadgeObject>;
  listDdlbadges = [] as Array<BadgeObject>;

  totalItems = 0;
  currentPage = 1;
  pageSize = 10;
  previous = 0;
  isNext = true;
  errors = {};

  /**
   * Get badges list
   * @returns Array<BadgeObject>
   */
  get badgesList(): Array<BadgeObject> {
    return this.badges;
  }

  /**
   * Get all none ive badges list
   * @returns Array<BadgeObject>
   */
  get allListBadges(): Array<BadgeObject> {
    return this.listDdlbadges;
  }

  /**
   * Get total items
   * @returns number
   */
  get badgesListCount(): number {
    return this.totalItems;
  }

  @Mutation
  [Mutations.SET_BADGES](data) {
    this.badges = data.data;
    this.totalItems = data.totalItems;
    this.currentPage = data.currentPage;
    this.pageSize = data.pageSize;
    this.isNext = data.isNext;
    this.previous = data.previous;
    this.errors = {};
  }

  @Mutation
  [Mutations.SET_BADGE_CURRENT_PAGE](page) {
    this.currentPage = page;
  }

  @Mutation
  [Mutations.SET_ALL_BADGES](data) {
    this.listDdlbadges = data.data;
  }

  @Mutation
  [Mutations.RESET_BADGES_LIST]() {
    this.badges = [] as Array<BadgeObject>;
    this.totalItems = 0;
    this.currentPage = 1;
    this.pageSize = 10;
    this.previous = 0;
    this.isNext = true;
    this.errors = {};
  }

  @Action
  [Actions.RESET_BADGES_STORE]() {
    this.context.commit(Mutations.RESET_BADGES_LIST);
  }

  @Action
  [Actions.CREATE_BADGE](data) {
    ApiService.setAuthorizationHeader();
    return ApiService.post('/badges', data)
      .then(({ data }) => {
        this.context.commit(Mutations.RESET_BADGES_LIST);
        return data.data;
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.DELETE_BADGE](id) {
    ApiService.setAuthorizationHeader();
    return ApiService.delete('/badges', id)
      .then(() => {
        this.context.commit(Mutations.RESET_BADGES_LIST);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.UPDATE_BADGE]({ id, data }) {
    ApiService.setAuthorizationHeader();
    return ApiService.update('/badges', id, data)
      .then(() => {
        this.context.commit(Mutations.RESET_BADGES_LIST);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.UPDATE_BADGE_CURRENT_PAGE](val) {
    this.context.commit(Mutations.SET_BADGE_CURRENT_PAGE, val);
  }

  @Action
  [Actions.GET_BADGE](id) {
    ApiService.setAuthorizationHeader();
    return ApiService.get('/badges', id);
  }

  @Action
  [Actions.GET_BADGES]() {
    ApiService.setAuthorizationHeader();
    return ApiService.query('/badges', {
      params: { page: this.currentPage },
    })
      .then(({ data }) => {
        this.context.commit(Mutations.SET_BADGES, data);
      })
      .catch(({ response }) => {
        console.error(response);
        // this.context.commit(Mutations.SET_ERROR, {
        //   [response.statusText]: [response.data.message],
        // });
      });
  }

  @Action
  [Actions.GET_ALL_BADGES]() {
    ApiService.setAuthorizationHeader();
    return ApiService.get('/badges/all')
      .then(({ data }) => {
        this.context.commit(Mutations.SET_ALL_BADGES, data);
        return data.data;
      })
      .catch(({ response }) => {
        console.error(response);
        // this.context.commit(Mutations.SET_ERROR, {
        //   [response.statusText]: [response.data.message],
        // });
      });
  }

  @Action
  [Actions.UPLOAD_BADGE]({ data, badgeId }) {
    ApiService.setAuthorizationHeader();
    ApiService.setMultipartHeader();
    return ApiService.post(`/badges/uploadBadge/${badgeId}`, data)
      .then(({ data }) => {
        return data.data;
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }
}
